import * as React from 'react';

function ActivityImage() {
	return (
		<div className='activity-empty-image'>
			<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 200 155'>
				<path className='cls-2' />
				<path
					className='cls-3'
					d='M145.92,143.3h-23.4a1.38,1.38,0,0,1-1.37-1.37V128.2a1.38,1.38,0,0,1,1.38-1.37h23.4a1.38,1.38,0,0,1,1.38,1.38v13.73A1.38,1.38,0,0,1,145.92,143.3Zm-23.4-15.73a.63.63,0,0,0-.62.63v13.73a.63.63,0,0,0,.63.63h23.4a.63.63,0,0,0,.63-.62V128.2a.63.63,0,0,0-.62-.62Z'
				/>
				<path
					className='cls-3'
					d='M146.88,127.46H121.54a1.38,1.38,0,0,1-1.37-1.37v-.9a1.38,1.38,0,0,1,1.38-1.37h25.34a1.38,1.38,0,0,1,1.38,1.38v.9A1.38,1.38,0,0,1,146.88,127.46Zm-25.34-2.9a.63.63,0,0,0-.62.63v.9a.63.63,0,0,0,.63.63h25.34a.63.63,0,0,0,.63-.62v-.9a.63.63,0,0,0-.62-.62Z'
				/>
				<path
					className='cls-3'
					d='M138.87,130.12h-9.44a1.22,1.22,0,0,1,0-2.44h9.44a1.22,1.22,0,1,1,0,2.44Zm-9.44-1.69a.47.47,0,0,0,0,.94h9.44a.47.47,0,1,0,0-.94Z'
				/>
				<path
					className='cls-3'
					d='M150.3,124.55H125.63a.74.74,0,0,1-.74-.74v-15a.74.74,0,0,1,.74-.74H150.3a.74.74,0,0,1,.74.74v.75a.37.37,0,1,1-.75,0v-.75H125.63v15H150.3v-12a.38.38,0,0,1,.75,0v12.05A.74.74,0,0,1,150.3,124.55Z'
				/>
				<path
					className='cls-3'
					d='M150.63,108.71H125.29a1.38,1.38,0,0,1-1.37-1.37v-.9a1.38,1.38,0,0,1,1.38-1.37h25.34a1.38,1.38,0,0,1,1.38,1.38v.9A1.38,1.38,0,0,1,150.63,108.71Zm-25.34-2.9a.63.63,0,0,0-.62.63v.9a.63.63,0,0,0,.63.63h25.34a.63.63,0,0,0,.63-.62v-.9a.63.63,0,0,0-.62-.62Z'
				/>
				<path
					className='cls-3'
					d='M142.62,111.37h-9.44a1.22,1.22,0,1,1,0-2.44h9.44a1.22,1.22,0,1,1,0,2.44Zm-9.44-1.69a.47.47,0,1,0,0,.94h9.44a.47.47,0,1,0,0-.94Z'
				/>
				<path
					className='cls-3'
					d='M145.6,105.49H122.2a1.38,1.38,0,0,1-1.37-1.37V90.39A1.38,1.38,0,0,1,122.2,89h23.4A1.38,1.38,0,0,1,147,90.39v13.73A1.38,1.38,0,0,1,145.6,105.49ZM122.2,89.76a.63.63,0,0,0-.62.63v13.73a.63.63,0,0,0,.63.63h23.4a.63.63,0,0,0,.63-.62V90.39a.63.63,0,0,0-.62-.62Z'
				/>
				<path
					className='cls-3'
					d='M146.57,89.64H121.23a1.38,1.38,0,0,1-1.37-1.37v-.9A1.38,1.38,0,0,1,121.23,86h25.34a1.38,1.38,0,0,1,1.38,1.38v.9A1.38,1.38,0,0,1,146.57,89.64Zm-25.34-2.9a.63.63,0,0,0-.62.63v.9a.63.63,0,0,0,.63.63h25.34a.63.63,0,0,0,.63-.62v-.9a.63.63,0,0,0-.62-.62Z'
				/>
				<path
					className='cls-3'
					d='M138.56,92.3h-9.44a1.22,1.22,0,1,1,0-2.44h9.44a1.22,1.22,0,1,1,0,2.44Zm-9.44-1.69a.47.47,0,1,0,0,.94h9.44a.47.47,0,1,0,0-.94Z'
				/>
				<path
					className='cls-3'
					d='M138.1,86.74H114.7a1.38,1.38,0,0,1-1.37-1.37V71.64a1.38,1.38,0,0,1,1.38-1.37h23.4a1.38,1.38,0,0,1,1.38,1.38V85.36A1.38,1.38,0,0,1,138.1,86.74ZM114.7,71a.63.63,0,0,0-.62.63V85.36a.63.63,0,0,0,.63.63h23.4a.63.63,0,0,0,.63-.62V71.64a.63.63,0,0,0-.62-.62Z'
				/>
				<path
					className='cls-3'
					d='M139.07,70.89H113.73a1.38,1.38,0,0,1-1.37-1.37v-.9a1.38,1.38,0,0,1,1.38-1.37h25.34a1.38,1.38,0,0,1,1.38,1.38v.9A1.38,1.38,0,0,1,139.07,70.89ZM113.73,68a.63.63,0,0,0-.62.63v.9a.63.63,0,0,0,.63.63h25.34a.63.63,0,0,0,.63-.62v-.9a.63.63,0,0,0-.62-.62Z'
				/>
				<path
					className='cls-3'
					d='M131.06,73.55h-9.44a1.22,1.22,0,1,1,0-2.44h9.44a1.22,1.22,0,1,1,0,2.44Zm-9.44-1.69a.47.47,0,1,0,0,.94h9.44a.47.47,0,1,0,0-.94Z'
				/>
				<path
					className='cls-3'
					d='M139.05,67.36H114.38a.74.74,0,0,1-.74-.74v-15a.74.74,0,0,1,.74-.74h24.68a.74.74,0,0,1,.74.74V54a.38.38,0,0,1-.75,0V51.63H114.38v15h24.67V56.26a.38.38,0,1,1,.75,0V66.62A.74.74,0,0,1,139.05,67.36Z'
				/>
				<path
					className='cls-3'
					d='M140,51.51H113.41a.74.74,0,0,1-.74-.74V48.6a.74.74,0,0,1,.74-.74h3.5a.37.37,0,0,1,0,.75h-3.5v2.16H140V48.6H119.15a.38.38,0,0,1,0-.75H140a.74.74,0,0,1,.74.74v2.17A.74.74,0,0,1,140,51.51Z'
				/>
				<path
					className='cls-3'
					d='M131.37,54.18h-9.44a1.22,1.22,0,1,1,0-2.44h9.44a1.22,1.22,0,1,1,0,2.44Zm-9.44-1.69a.47.47,0,1,0,0,.94h9.44a.47.47,0,1,0,0-.94Z'
				/>
				<path className='cls-3' d='M94,30H90.23a.38.38,0,0,1,0-.75H94A.38.38,0,0,1,94,30Z' />
				<path
					className='cls-3'
					d='M112,144.78H43.44a.74.74,0,0,1-.74-.74V30a.74.74,0,0,1,.74-.74H86.3a.38.38,0,0,1,0,.75H43.44V144H112V30H97.9a.38.38,0,0,1,0-.75H112a.74.74,0,0,1,.74.74V144A.74.74,0,0,1,112,144.78Z'
				/>
				<path
					className='cls-3'
					d='M75.19,58.62H45.69a1.38,1.38,0,0,1-1.37-1.37V33.92a1.38,1.38,0,0,1,1.38-1.37H75.19a1.38,1.38,0,0,1,1.38,1.38V57.24A1.38,1.38,0,0,1,75.19,58.62ZM45.69,33.3a.63.63,0,0,0-.62.63V57.24a.63.63,0,0,0,.63.63H75.19a.63.63,0,0,0,.63-.62V33.92a.63.63,0,0,0-.62-.62Z'
				/>
				<path
					className='cls-3'
					d='M72.59,56.64H48.29a1.38,1.38,0,0,1-1.37-1.37V35.89a1.38,1.38,0,0,1,1.38-1.37h24.3A1.38,1.38,0,0,1,74,35.89V55.27A1.38,1.38,0,0,1,72.59,56.64ZM48.29,35.27a.63.63,0,0,0-.62.63V55.27a.63.63,0,0,0,.63.63h24.3a.63.63,0,0,0,.63-.62V35.89a.63.63,0,0,0-.62-.62Z'
				/>
				<path
					className='cls-3'
					d='M66,44.15H54.86a1.38,1.38,0,0,1-1.37-1.37v-2.6a1.38,1.38,0,0,1,1.38-1.37H66a1.38,1.38,0,0,1,1.38,1.38v2.6A1.38,1.38,0,0,1,66,44.15Zm-11.15-4.6a.63.63,0,0,0-.62.63v2.6a.63.63,0,0,0,.63.63H66a.63.63,0,0,0,.63-.62v-2.6a.63.63,0,0,0-.62-.62Z'
				/>
				<path className='cls-3' d='M62,46.45h-7.3a.38.38,0,1,1,0-.75H62a.38.38,0,0,1,0,.75Z' />
				<path className='cls-3' d='M66.19,46.45h-2a.38.38,0,0,1,0-.75h2a.38.38,0,0,1,0,.75Z' />
				<path
					className='cls-3'
					d='M109.71,58.62H80.21a1.38,1.38,0,0,1-1.37-1.37V33.92a1.38,1.38,0,0,1,1.38-1.37h29.51a1.38,1.38,0,0,1,1.38,1.38V57.24A1.38,1.38,0,0,1,109.71,58.62ZM80.21,33.3a.63.63,0,0,0-.62.63V57.24a.63.63,0,0,0,.63.63h29.51a.63.63,0,0,0,.63-.62V33.92a.63.63,0,0,0-.62-.62Z'
				/>
				<path
					className='cls-3'
					d='M107.11,56.64H82.81a1.38,1.38,0,0,1-1.37-1.37V35.89a1.38,1.38,0,0,1,1.38-1.37h24.3a1.38,1.38,0,0,1,1.38,1.38V55.27A1.38,1.38,0,0,1,107.11,56.64ZM82.81,35.27a.63.63,0,0,0-.62.63V55.27a.63.63,0,0,0,.63.63h24.3a.63.63,0,0,0,.63-.62V35.89a.63.63,0,0,0-.62-.62Z'
				/>
				<path
					className='cls-3'
					d='M100.53,44.15H89.38A1.38,1.38,0,0,1,88,42.77v-2.6a1.38,1.38,0,0,1,1.38-1.37h11.15a1.38,1.38,0,0,1,1.38,1.38v2.6A1.38,1.38,0,0,1,100.53,44.15Zm-11.15-4.6a.63.63,0,0,0-.62.63v2.6a.63.63,0,0,0,.63.63h11.15a.63.63,0,0,0,.63-.62v-2.6a.63.63,0,0,0-.63-.62Z'
				/>
				<path className='cls-3' d='M100.71,46.45H89.21a.38.38,0,0,1,0-.75h11.51a.38.38,0,1,1,0,.75Z' />
				<path
					className='cls-3'
					d='M75.19,85.25H45.69a1.38,1.38,0,0,1-1.37-1.37V60.56a1.38,1.38,0,0,1,1.38-1.37H75.19a1.38,1.38,0,0,1,1.38,1.38V83.88A1.38,1.38,0,0,1,75.19,85.25ZM45.69,59.93a.63.63,0,0,0-.62.63V83.88a.63.63,0,0,0,.63.63H75.19a.63.63,0,0,0,.63-.62V60.56a.63.63,0,0,0-.62-.62Z'
				/>
				<path
					className='cls-3'
					d='M72.59,83.28H48.29a1.38,1.38,0,0,1-1.37-1.37V62.53a1.38,1.38,0,0,1,1.38-1.37h24.3A1.38,1.38,0,0,1,74,62.53V81.91A1.38,1.38,0,0,1,72.59,83.28ZM48.29,61.91a.63.63,0,0,0-.62.63V81.91a.63.63,0,0,0,.63.63h24.3a.63.63,0,0,0,.63-.62V62.53a.63.63,0,0,0-.62-.62Z'
				/>
				<path
					className='cls-3'
					d='M66,70.79H54.86a1.38,1.38,0,0,1-1.37-1.37v-2.6a1.38,1.38,0,0,1,1.38-1.37H66a1.38,1.38,0,0,1,1.38,1.38v2.6A1.38,1.38,0,0,1,66,70.79Zm-11.15-4.6a.63.63,0,0,0-.62.63v2.6a.63.63,0,0,0,.63.63H66a.63.63,0,0,0,.63-.62v-2.6a.63.63,0,0,0-.62-.62Z'
				/>
				<path className='cls-3' d='M66.19,73.09H54.69a.38.38,0,1,1,0-.75H66.19a.38.38,0,0,1,0,.75Z' />
				<path
					className='cls-3'
					d='M109.71,85.25H80.21a1.38,1.38,0,0,1-1.37-1.37V60.56a1.38,1.38,0,0,1,1.38-1.37h29.51a1.38,1.38,0,0,1,1.38,1.38V83.88A1.38,1.38,0,0,1,109.71,85.25ZM80.21,59.93a.63.63,0,0,0-.62.63V83.88a.63.63,0,0,0,.63.63h29.51a.63.63,0,0,0,.63-.62V60.56a.63.63,0,0,0-.62-.62Z'
				/>
				<path
					className='cls-3'
					d='M107.11,83.28H82.81a1.38,1.38,0,0,1-1.37-1.37V62.53a1.38,1.38,0,0,1,1.38-1.37h24.3a1.38,1.38,0,0,1,1.38,1.38V81.91A1.38,1.38,0,0,1,107.11,83.28ZM82.81,61.91a.63.63,0,0,0-.62.63V81.91a.63.63,0,0,0,.63.63h24.3a.63.63,0,0,0,.63-.62V62.53a.63.63,0,0,0-.62-.62Z'
				/>
				<path
					className='cls-3'
					d='M100.53,70.79H89.38A1.38,1.38,0,0,1,88,69.41v-2.6a1.38,1.38,0,0,1,1.38-1.37h11.15a1.38,1.38,0,0,1,1.38,1.38v2.6A1.38,1.38,0,0,1,100.53,70.79Zm-11.15-4.6a.63.63,0,0,0-.62.63v2.6a.63.63,0,0,0,.63.63h11.15a.63.63,0,0,0,.63-.62v-2.6a.63.63,0,0,0-.63-.62Z'
				/>
				<path className='cls-3' d='M100.71,73.09H89.21a.38.38,0,0,1,0-.75h11.51a.38.38,0,1,1,0,.75Z' />
				<path
					className='cls-3'
					d='M75.83,111.89H45a.74.74,0,0,1-.74-.74V97a.37.37,0,0,1,.75,0v14.12H75.83V86.56H45v6.91a.37.37,0,0,1-.75,0V86.56a.74.74,0,0,1,.74-.74H75.83a.74.74,0,0,1,.74.74v24.59A.74.74,0,0,1,75.83,111.89Z'
				/>
				<path
					className='cls-3'
					d='M72.59,109.92H48.29a1.38,1.38,0,0,1-1.37-1.37V89.17a1.38,1.38,0,0,1,1.38-1.37h24.3A1.38,1.38,0,0,1,74,89.17v19.38A1.38,1.38,0,0,1,72.59,109.92ZM48.29,88.54a.63.63,0,0,0-.62.63v19.38a.63.63,0,0,0,.63.63h24.3a.63.63,0,0,0,.63-.62V89.17a.63.63,0,0,0-.62-.62Z'
				/>
				<path
					className='cls-3'
					d='M66,97.42H54.86A1.38,1.38,0,0,1,53.49,96v-2.6a1.38,1.38,0,0,1,1.38-1.37H66a1.38,1.38,0,0,1,1.38,1.38V96A1.38,1.38,0,0,1,66,97.42Zm-11.15-4.6a.63.63,0,0,0-.62.63V96a.63.63,0,0,0,.63.63H66a.63.63,0,0,0,.63-.62v-2.6a.63.63,0,0,0-.62-.62Z'
				/>
				<path className='cls-3' d='M66.19,99.72H54.69a.38.38,0,1,1,0-.75H66.19a.38.38,0,0,1,0,.75Z' />
				<path
					className='cls-3'
					d='M109.71,111.89H80.21a1.38,1.38,0,0,1-1.37-1.37V87.19a1.38,1.38,0,0,1,1.38-1.37h29.51a1.38,1.38,0,0,1,1.38,1.38v23.32A1.38,1.38,0,0,1,109.71,111.89ZM80.21,86.57a.63.63,0,0,0-.62.63v23.32a.63.63,0,0,0,.63.63h29.51a.63.63,0,0,0,.63-.62V87.19a.63.63,0,0,0-.62-.62Z'
				/>
				<path
					className='cls-3'
					d='M107.11,109.92H82.81a1.38,1.38,0,0,1-1.37-1.37V89.17a1.38,1.38,0,0,1,1.38-1.37h24.3a1.38,1.38,0,0,1,1.38,1.38v19.38A1.38,1.38,0,0,1,107.11,109.92ZM82.81,88.54a.63.63,0,0,0-.62.63v19.38a.63.63,0,0,0,.63.63h24.3a.63.63,0,0,0,.63-.62V89.17a.63.63,0,0,0-.62-.62Z'
				/>
				<path
					className='cls-3'
					d='M101.17,97.42H88.75a.74.74,0,0,1-.74-.74V92.81a.74.74,0,0,1,.74-.74h4.66a.38.38,0,0,1,0,.75H88.75v3.86h12.41V92.81H96a.38.38,0,0,1,0-.75h5.15a.74.74,0,0,1,.74.74v3.88A.74.74,0,0,1,101.17,97.42Z'
				/>
				<path className='cls-3' d='M100.71,99.72H89.21a.38.38,0,0,1,0-.75h11.51a.38.38,0,1,1,0,.75Z' />
				<path
					className='cls-3'
					d='M75.83,138.53H52.08a.38.38,0,1,1,0-.75H75.83V113.2H45v24.58h2.53a.38.38,0,0,1,0,.75H45a.74.74,0,0,1-.74-.74V113.2a.74.74,0,0,1,.74-.74H75.83a.74.74,0,0,1,.74.74v24.59A.74.74,0,0,1,75.83,138.53Z'
				/>
				<path
					className='cls-3'
					d='M72.59,136.55H48.29a1.38,1.38,0,0,1-1.37-1.37V115.8a1.38,1.38,0,0,1,1.38-1.37h24.3A1.38,1.38,0,0,1,74,115.8v19.38A1.38,1.38,0,0,1,72.59,136.55Zm-24.3-21.37a.63.63,0,0,0-.62.63v19.38a.63.63,0,0,0,.63.63h24.3a.63.63,0,0,0,.63-.62V115.8a.63.63,0,0,0-.62-.62Z'
				/>
				<path
					className='cls-3'
					d='M66,124.06H54.86a1.38,1.38,0,0,1-1.37-1.37v-2.6a1.38,1.38,0,0,1,1.38-1.37H66a1.38,1.38,0,0,1,1.38,1.38v2.6A1.38,1.38,0,0,1,66,124.06Zm-11.15-4.6a.63.63,0,0,0-.62.63v2.6a.63.63,0,0,0,.63.63H66a.63.63,0,0,0,.63-.62v-2.6a.63.63,0,0,0-.62-.62Z'
				/>
				<path className='cls-3' d='M66.19,126.36H54.69a.38.38,0,1,1,0-.75H66.19a.38.38,0,0,1,0,.75Z' />
				<path
					className='cls-3'
					d='M109.71,138.53H80.21a1.38,1.38,0,0,1-1.37-1.37V113.83a1.38,1.38,0,0,1,1.38-1.37h29.51a1.38,1.38,0,0,1,1.38,1.38v23.32A1.38,1.38,0,0,1,109.71,138.53ZM80.21,113.21a.63.63,0,0,0-.62.63v23.32a.63.63,0,0,0,.63.63h29.51a.63.63,0,0,0,.63-.62V113.83a.63.63,0,0,0-.62-.62Z'
				/>
				<path
					className='cls-3'
					d='M107.11,136.55H82.81a1.38,1.38,0,0,1-1.37-1.37V115.8a1.38,1.38,0,0,1,1.38-1.37h24.3a1.38,1.38,0,0,1,1.38,1.38v19.38A1.38,1.38,0,0,1,107.11,136.55Zm-24.3-21.37a.63.63,0,0,0-.62.63v19.38a.63.63,0,0,0,.63.63h24.3a.63.63,0,0,0,.63-.62V115.8a.63.63,0,0,0-.62-.62Z'
				/>
				<path
					className='cls-3'
					d='M100.53,124.06H89.38A1.38,1.38,0,0,1,88,122.68v-2.6a1.38,1.38,0,0,1,1.38-1.37h11.15a1.38,1.38,0,0,1,1.38,1.38v2.6A1.38,1.38,0,0,1,100.53,124.06Zm-11.15-4.6a.63.63,0,0,0-.62.63v2.6a.63.63,0,0,0,.63.63h11.15a.63.63,0,0,0,.63-.62v-2.6a.63.63,0,0,0-.63-.62Z'
				/>
				<path className='cls-3' d='M100.71,126.36H89.21a.38.38,0,0,1,0-.75h11.51a.38.38,0,0,1,0,.75Z' />
				<path
					className='cls-3'
					d='M40.51,145H11.18a1.1,1.1,0,0,1-1.1-1.1V133.23a.37.37,0,0,1,.75,0V143.9a.35.35,0,0,0,.35.35H40.51a.35.35,0,0,0,.35-.35v-18h-30v2.48a.38.38,0,0,1-.75,0V125.2H41.62V143.9A1.1,1.1,0,0,1,40.51,145Z'
				/>
				<path
					className='cls-3'
					d='M40.65,125.8H11a2.13,2.13,0,1,1,0-4.27H40.65a2.13,2.13,0,1,1,0,4.27ZM11,122.28a1.38,1.38,0,1,0,0,2.77H40.65a1.38,1.38,0,1,0,0-2.77Z'
				/>
				<path
					className='cls-3'
					d='M31.79,129H27.84a.38.38,0,1,1,0-.75h3.94a.35.35,0,0,0,.35-.35v-.6a.35.35,0,0,0-.35-.35h-12a.35.35,0,0,0-.35.35v.6a.35.35,0,0,0,.35.35H25.7a.38.38,0,0,1,0,.75H19.76a1.1,1.1,0,0,1-1.1-1.1v-.6a1.1,1.1,0,0,1,1.1-1.1h12a1.1,1.1,0,0,1,1.1,1.1v.6A1.1,1.1,0,0,1,31.79,129Z'
				/>
				<rect className='cls-4' x='82.89' y='120.51' width='17.66' height='2.69' rx='1.34' ry='1.34' />
				<path
					className='cls-5'
					d='M110.28,137.25H76.14c-.17,0-.29-.16-.29-.39l-.15-19.55a.78.78,0,0,1,.69-.81H96.23l1.94-1.9a.76.76,0,0,1,.54-.22H110a.76.76,0,0,1,.68.78l-.11,21.7C110.57,137.08,110.44,137.25,110.28,137.25Z'
				/>
				<path
					className='cls-2'
					d='M109.71,138.12H75.46a.71.71,0,0,1-.67-.76l-.07-19.67a1.25,1.25,0,0,1,.36-.88,1,1,0,0,1,.7-.31h19.8l1.72-1.73a1.4,1.4,0,0,1,1-.41h11.23a1,1,0,0,1,.7.31,1.22,1.22,0,0,1,.35.86l-.2,21.83A.71.71,0,0,1,109.71,138.12Zm-34.16-.75h34.07l.21-21.85a.47.47,0,0,0-.13-.32.26.26,0,0,0-.17-.09H98.29a.65.65,0,0,0-.46.2L96,117.06a.63.63,0,0,1-.45.18H75.8a.26.26,0,0,0-.17.09.5.5,0,0,0-.14.35l.07,19.67A0,0,0,0,1,75.54,137.37Zm34.54-9.58h0Z'
				/>
				<path
					className='cls-6'
					d='M80.86,110.17,79.79,110a.29.29,0,0,0-.33.26l-2.95,24.49a.29.29,0,0,0,.26.33l11.13,1.34,10.73,1.29a.29.29,0,0,0,.33-.26L101.9,113a.29.29,0,0,0-.26-.33l-16.29-2'
				/>
				<path
					className='cls-6'
					d='M84.89,111.12l16.29,2a.29.29,0,0,1,.26.33l-2.95,24.49a.29.29,0,0,1-.33.26l-10.73-1.29L76.3,135.51a.29.29,0,0,1-.26-.33L79,110.7a.29.29,0,0,1,.33-.26l1.08.13.83.1.65.08.88.11,1.3.16Z'
				/>
				<path
					className='cls-2'
					d='M98.2,138.52h-.08l-21.86-2.63a.67.67,0,0,1-.58-.74l2.95-24.49a.67.67,0,0,1,.74-.58l21.86,2.63a.67.67,0,0,1,.58.74l-2.95,24.49a.67.67,0,0,1-.66.59Zm-21.77-3.37,21.7,2.61,2.93-24.32-16.21-2h0l-5.49-.66Z'
				/>
				<path
					className='cls-6'
					d='M77.5,113.87l-1.09,0a.29.29,0,0,0-.28.31l1.07,24.64a.29.29,0,0,0,.31.28l11.2-.49,10.79-.47a.29.29,0,0,0,.28-.31l-1.07-24.64a.29.29,0,0,0-.31-.28L82,113.68'
				/>
				<path
					className='cls-2'
					d='M77.1,140a.67.67,0,0,1-.67-.64l-1.07-24.64A.67.67,0,0,1,76,114l1.09,0a.4.4,0,0,1,.39.36.38.38,0,0,1-.36.39l-1,0,1.06,24.48L99,138.3l-1.06-24.48-16.31.71a.39.39,0,0,1-.39-.36.38.38,0,0,1,.36-.39L98,113.07a.68.68,0,0,1,.7.64l1.07,24.64a.67.67,0,0,1-.64.7l-22,1Z'
				/>
				<path className='cls-6' d='M80.79,114.19l-1.3.06' />
				<path className='cls-2' d='M79.48,114.62a.38.38,0,0,1,0-.75l1.3-.06a.38.38,0,0,1,0,.75l-1.3.06Z' />
				<path className='cls-6' d='M78.59,114.28l-.65,0' />
				<path className='cls-2' d='M77.94,114.69a.38.38,0,0,1,0-.75l.65,0a.38.38,0,0,1,0,.75l-.65,0Z' />
				<line className='cls-6' x1='77.77' y1='116.81' x2='82.83' y2='116.59' />
				<path
					className='cls-2'
					d='M77.77,117.19a.38.38,0,0,1,0-.75l5.07-.22a.39.39,0,0,1,.39.36.38.38,0,0,1-.36.39l-5.07.22Z'
				/>
				<path className='cls-6' d='M77.82,118.06l3.65-.16' />
				<path className='cls-2' d='M77.84,118.43l0-.75,3.65-.16a.38.38,0,0,1,0,.75Z' />
				<line className='cls-6' x1='77.88' y1='119.3' x2='80.18' y2='119.2' />
				<path
					className='cls-2'
					d='M77.88,119.68a.38.38,0,0,1,0-.75l2.3-.1a.4.4,0,0,1,.39.36.38.38,0,0,1-.36.39l-2.3.1Z'
				/>
				<line className='cls-6' x1='81.46' y1='119.15' x2='82.76' y2='119.09' />
				<path
					className='cls-2'
					d='M81.46,119.52a.38.38,0,0,1,0-.75l1.3-.06a.39.39,0,0,1,.39.36.38.38,0,0,1-.36.39l-1.3.06Z'
				/>
				<line className='cls-6' x1='91.69' y1='118.7' x2='96.75' y2='118.48' />
				<path
					className='cls-2'
					d='M91.69,119.08a.38.38,0,0,1,0-.75l5.07-.22a.41.41,0,0,1,.39.36.38.38,0,0,1-.36.39l-5.07.22Z'
				/>
				<line className='cls-6' x1='92.09' y1='119.93' x2='96.81' y2='119.73' />
				<path
					className='cls-2'
					d='M92.09,120.31a.38.38,0,0,1,0-.75l4.71-.2a.39.39,0,0,1,.39.36.38.38,0,0,1-.36.39l-4.71.2Z'
				/>
				<line className='cls-6' x1='94.56' y1='121.07' x2='96.86' y2='120.97' />
				<path
					className='cls-2'
					d='M94.56,121.45a.38.38,0,0,1,0-.75l2.3-.1a.38.38,0,0,1,.39.36.38.38,0,0,1-.36.39l-2.3.1Z'
				/>
				<line className='cls-6' x1='78.17' y1='126.01' x2='93.57' y2='125.34' />
				<path
					className='cls-2'
					d='M78.17,126.38a.38.38,0,0,1,0-.75L93.56,125a.38.38,0,0,1,.39.36.38.38,0,0,1-.36.39l-15.41.67Z'
				/>
				<line className='cls-6' x1='81.45' y1='124.49' x2='82.75' y2='124.43' />
				<path
					className='cls-2'
					d='M81.45,124.86a.38.38,0,0,1,0-.75l1.3-.06a.41.41,0,0,1,.39.36.38.38,0,0,1-.36.39l-1.3.06Z'
				/>
				<line className='cls-6' x1='78.11' y1='124.63' x2='80.41' y2='124.53' />
				<path
					className='cls-2'
					d='M78.11,125a.38.38,0,0,1,0-.75l2.3-.1a.41.41,0,0,1,.39.36.38.38,0,0,1-.36.39l-2.3.1Z'
				/>
				<line className='cls-6' x1='78.23' y1='127.39' x2='95.3' y2='126.65' />
				<path className='cls-2' d='M78.23,127.76a.38.38,0,0,1,0-.75l17.07-.74a.38.38,0,0,1,0,.75l-17.07.74Z' />
				<line className='cls-6' x1='78.29' y1='128.76' x2='92.03' y2='128.17' />
				<path
					className='cls-2'
					d='M78.29,129.14a.38.38,0,0,1,0-.75L92,127.79a.4.4,0,0,1,.39.36.38.38,0,0,1-.36.39l-13.74.59Z'
				/>
				<path
					className='cls-2'
					d='M90.48,132.27l0-.81-1.58.78.46-1.08-1.37,1a.38.38,0,0,1-.45-.6l3.62-2.74-.77,1.82.81-.4,0,1,2.87-1a.38.38,0,0,1,.24.71Z'
				/>
				<g className='cls-7'>
					<path
						className='cls-2'
						d='M78.57,126.72a.38.38,0,0,1,0-.75L94,125.31a.39.39,0,0,1,.39.36.38.38,0,0,1-.36.39l-15.41.67Z'
					/>
					<path
						className='cls-2'
						d='M81.86,125.2a.38.38,0,0,1,0-.75l1.3-.06a.38.38,0,0,1,.39.36.38.38,0,0,1-.36.39l-1.3.06Z'
					/>
					<path
						className='cls-2'
						d='M78.51,125.35a.38.38,0,0,1,0-.75l2.3-.1a.38.38,0,0,1,.39.36.38.38,0,0,1-.36.39l-2.3.1Z'
					/>
					<path
						className='cls-2'
						d='M78.63,128.1a.38.38,0,0,1,0-.75l17.07-.74a.39.39,0,0,1,.39.36.38.38,0,0,1-.36.39l-17.07.74Z'
					/>
					<path
						className='cls-2'
						d='M78.69,129.48a.38.38,0,0,1,0-.75l13.74-.6a.4.4,0,0,1,.39.36.38.38,0,0,1-.36.39l-13.74.6Z'
					/>
				</g>
				<g className='cls-7'>
					<path
						className='cls-2'
						d='M78.18,117.53a.38.38,0,0,1,0-.75l5.07-.22a.39.39,0,0,1,.39.36.38.38,0,0,1-.36.39l-5.07.22Z'
					/>
					<path className='cls-2' d='M78.25,118.77l0-.75,3.72-.16a.39.39,0,0,1,.39.36.38.38,0,0,1-.36.39Z' />
					<path
						className='cls-2'
						d='M78.28,120a.38.38,0,0,1,0-.75l2.3-.1a.37.37,0,0,1,.39.36.38.38,0,0,1-.36.39l-2.3.1Z'
					/>
					<path
						className='cls-2'
						d='M81.87,119.86a.38.38,0,0,1,0-.75l1.3-.06a.4.4,0,0,1,.39.36.38.38,0,0,1-.36.39l-1.3.06Z'
					/>
				</g>
				<g className='cls-7'>
					<line className='cls-6' x1='92.09' y1='119.04' x2='97.16' y2='118.82' />
					<path
						className='cls-2'
						d='M92.09,119.42a.38.38,0,0,1,0-.75l5.07-.22a.38.38,0,0,1,.39.36.38.38,0,0,1-.36.39l-5.07.22Z'
					/>
					<line className='cls-6' x1='92.5' y1='120.27' x2='97.21' y2='120.07' />
					<path
						className='cls-2'
						d='M92.5,120.64a.38.38,0,0,1,0-.75l4.71-.2a.4.4,0,0,1,.39.36.38.38,0,0,1-.36.39l-4.71.2Z'
					/>
					<line className='cls-6' x1='94.96' y1='121.41' x2='97.27' y2='121.31' />
					<path
						className='cls-2'
						d='M95,121.78a.38.38,0,0,1,0-.75l2.3-.1a.38.38,0,0,1,.39.36.38.38,0,0,1-.36.39l-2.3.1Z'
					/>
				</g>
				<path
					className='cls-5'
					d='M109.15,138.73H75.84c-.16,0-.28-.17-.28-.4l-.15-20.07a.79.79,0,0,1,.67-.83H95.44l1.89-1.95a.73.73,0,0,1,.52-.23h11a.77.77,0,0,1,.66.8l-.11,22.28C109.43,138.56,109.31,138.73,109.15,138.73Z'
				/>
				<path
					className='cls-2'
					d='M108.59,139.61H75.17a.71.71,0,0,1-.66-.77l-.06-20.19a1.29,1.29,0,0,1,.37-.91,1,1,0,0,1,.68-.3H94.76l1.72-1.77a1.36,1.36,0,0,1,1-.42h11a1,1,0,0,1,.68.3,1.26,1.26,0,0,1,.36.89l-.19,22.41A.71.71,0,0,1,108.59,139.61Zm-33.33-.75h33.23l.2-22.44a.51.51,0,0,0-.14-.35.23.23,0,0,0-.14-.08h-11a.6.6,0,0,0-.43.2L95.27,118a.63.63,0,0,1-.45.19H75.5a.23.23,0,0,0-.15.08.56.56,0,0,0-.15.38l.06,20.19A0,0,0,0,1,75.26,138.86ZM109,129h0Z'
				/>
				<path
					className='cls-8'
					d='M109.84,143.83H73.53a2,2,0,0,1-2-2V118.4h40.31v23.43A2,2,0,0,1,109.84,143.83Z'
				/>
				<path
					className='cls-2'
					d='M111.05,144.49H71.88a.94.94,0,0,1-.94-.94v-15.1a.38.38,0,0,1,.75,0v15.1a.19.19,0,0,0,.19.19h39.17a.19.19,0,0,0,.19-.19V119.43l-39.56-.05v6.26a.38.38,0,0,1-.75,0v-6.45a.56.56,0,0,1,.56-.56l39.94.05a.56.56,0,0,1,.56.56v24.31A.94.94,0,0,1,111.05,144.49Z'
				/>
				<rect className='cls-9' x='82.85' y='120.48' width='17.66' height='2.69' rx='1.34' ry='1.34' />
				<path
					className='cls-2'
					d='M99.47,123.85H83.27a1.1,1.1,0,0,1-1.1-1.1v-1.23a1.1,1.1,0,0,1,1.1-1.1h16.2a1.1,1.1,0,0,1,1.1,1.1v1.23A1.1,1.1,0,0,1,99.47,123.85Zm-16.2-2.69a.35.35,0,0,0-.35.35v1.23a.35.35,0,0,0,.35.35h16.2a.35.35,0,0,0,.35-.35v-1.23a.35.35,0,0,0-.35-.35Z'
				/>
				<rect className='cls-10' x='83.05' y='129.27' width='18.18' height='6.44' rx='1' ry='1' />
				<path
					className='cls-2'
					d='M100.49,136.47H83a.74.74,0,0,1-.74-.74V130a.74.74,0,0,1,.74-.74H97a.38.38,0,0,1,0,.75H83v5.7h17.44V130H98.75a.38.38,0,1,1,0-.75h1.74a.74.74,0,0,1,.74.74v5.71A.74.74,0,0,1,100.49,136.47Z'
				/>
				<path className='cls-2' d='M96.69,132.21H86.84a.38.38,0,1,1,0-.75h9.85a.38.38,0,0,1,0,.75Z' />
				<path
					className='cls-2'
					d='
M97.63,134.48H85.89a.38.38,0,1,1,0-.75H97.63a.38.38,0,0,1,0,.75Z'
				/>
				<path
					className='cls-3'
					d='M38.09,122H33.76a.74.74,0,0,1-.74-.74V104.16a.74.74,0,0,1,.74-.74h1.17a.38.38,0,0,1,0,.75H33.76v17.1h4.32v-17.1H36.36a.38.38,0,0,1,0-.75h1.73a.74.74,0,0,1,.74.74v17.11A.74.74,0,0,1,38.09,122Z'
				/>
				<path
					className='cls-3'
					d='M36.8,114.45H35a1.38,1.38,0,0,1-1.37-1.37v-5.65A1.38,1.38,0,0,1,35,106H36.8a1.38,1.38,0,0,1,1.38,1.38v5.65A1.38,1.38,0,0,1,36.8,114.45ZM35,106.8a.63.63,0,0,0-.62.63v5.65a.63.63,0,0,0,.63.63H36.8a.63.63,0,0,0,.63-.62v-5.65a.63.63,0,0,0-.62-.62Z'
				/>
				<path
					className='cls-3'
					d='M35.92,120.09a1.15,1.15,0,1,1,1.15-1.15A1.15,1.15,0,0,1,35.92,120.09Zm0-1.56a.4.4,0,1,0,.4.4A.4.4,0,0,0,35.92,118.54Z'
				/>
				<path className='cls-3' d='M37.18,109.26H34.84a.38.38,0,1,1,0-.75h2.33a.38.38,0,1,1,0,.75Z' />
				<path className='cls-3' d='M37.18,112H34.84a.37.37,0,0,1,0-.75h2.33a.38.38,0,1,1,0,.75Z' />
				<path className='cls-3' d='M37.18,110.62H34.84a.38.38,0,0,1,0-.75h2.33a.38.38,0,0,1,0,.75Z' />
				<path
					className='cls-3'
					d='M31.66,122H28.6a1.38,1.38,0,0,1-1.37-1.37V104.8a1.38,1.38,0,0,1,1.38-1.37h3.06A1.38,1.38,0,0,1,33,104.8v15.84A1.38,1.38,0,0,1,31.66,122ZM28.6,104.17a.63.63,0,0,0-.62.63v15.84a.63.63,0,0,0,.63.63h3.06a.63.63,0,0,0,.63-.62V104.8a.63.63,0,0,0-.62-.62Z'
				/>
				<path
					className='cls-3'
					d='M31.64,114.45h-3a.74.74,0,0,1-.74-.74v-6.92a.74.74,0,0,1,.74-.74h1a.38.38,0,0,1,0,.75h-1v6.91h3v-6.91h-1a.38.38,0,1,1,0-.75h1a.74.74,0,0,1,.74.74v6.92A.74.74,0,0,1,31.64,114.45Z'
				/>
				<path
					className='cls-3'
					d='M30.13,120.09a1.15,1.15,0,1,1,1.15-1.15A1.15,1.15,0,0,1,30.13,120.09Zm0-1.56a.4.4,0,1,0,.4.4A.4.4,0,0,0,30.13,118.54Z'
				/>
				<path className='cls-3' d='M31.38,109.26H29a.38.38,0,0,1,0-.75h2.33a.38.38,0,1,1,0,.75Z' />
				<path className='cls-3' d='M31.38,112H29a.38.38,0,0,1,0-.75h2.33a.38.38,0,1,1,0,.75Z' />
				<path className='cls-3' d='M31.38,110.62H29a.38.38,0,1,1,0-.75h2.33a.38.38,0,0,1,0,.75Z' />
				<path
					className='cls-3'
					d='M22.15,121.84l-.25,0-3-.56a1.38,1.38,0,0,1-1.1-1.6l2.91-15.57a1.37,1.37,0,0,1,1.6-1.1l3,.56a1.38,1.38,0,0,1,1.1,1.6L23.5,120.72A1.38,1.38,0,0,1,22.15,121.84ZM19,120.52l3,.56a.62.62,0,0,0,.73-.5L25.67,105a.63.63,0,0,0-.5-.73l-3-.56a.62.62,0,0,0-.47.1.62.62,0,0,0-.26.4l-2.91,15.57a.63.63,0,0,0,.5.73Z'
				/>
				<path
					className='cls-3'
					d='M22.9,114.29l-.25,0-1.73-.32a1.38,1.38,0,0,1-1.1-1.6l1-5.56a1.37,1.37,0,0,1,1.6-1.1l1.73.32a1.37,1.37,0,0,1,1.1,1.6l-1,5.56A1.38,1.38,0,0,1,22.9,114.29Zm-1.85-1.08,1.73.32a.63.63,0,0,0,.73-.5l1-5.56a.62.62,0,0,0-.5-.73l-1.73-.32a.64.64,0,0,0-.47.1.62.62,0,0,0-.26.4l-1,5.56a.63.63,0,0,0,.5.73Z'
				/>
				<path
					className='cls-3'
					d='M21,119.68l-.21,0a1.15,1.15,0,0,1,0-2.27.38.38,0,0,1,.11.74.4.4,0,0,0,0,.79.42.42,0,0,0,.3-.06.4.4,0,0,0,.17-.26.4.4,0,0,1,.43-.33.35.35,0,0,1,.33.38v.1a1.15,1.15,0,0,1-1.13.94Z'
				/>
				<path className='cls-3' d='M24,109.25H24l-2.3-.43a.37.37,0,1,1,.14-.74l2.3.43a.37.37,0,0,1-.07.74Z' />
				<path
					className='cls-3'
					d='M23.54,111.92h-.07l-2.29-.43a.37.37,0,0,1-.3-.44.37.37,0,0,1,.44-.3l2.29.43a.37.37,0,0,1-.07.74Z'
				/>
				<path
					className='cls-3'
					d='M23.79,110.58h-.07l-2.3-.43a.37.37,0,1,1,.14-.74l2.3.43a.37.37,0,0,1-.07.74Z'
				/>
				<path
					className='cls-8'
					d='M153.5,143.83H116.83a2,2,0,0,1-2-2V118.17H155.5v23.66A2,2,0,0,1,153.5,143.83Z'
				/>
				<rect className='cls-4' x='126.16' y='120.3' width='17.82' height='2.71' rx='1.36' ry='1.36' />
				<rect className='cls-11' x='113.28' y='113.81' width='43.76' height='4.65' rx='2' ry='2' />
				<path
					className='cls-2'
					d='M154.35,144.49H114.83a1,1,0,0,1-.95-.95V118.78a.38.38,0,0,1,.75,0v24.76a.2.2,0,0,0,.2.2h39.52a.2.2,0,0,0,.2-.2V118.84a.38.38,0,0,1,.75,0v24.71A1,1,0,0,1,154.35,144.49Z'
				/>
				<path
					className='cls-2'
					d='M142.67,123.67H126.32a1.1,1.1,0,0,1-1.1-1.1v-1.25a1.1,1.1,0,0,1,1.1-1.1h16.36a1.1,1.1,0,0,1,1.1,1.1v1.25A1.1,1.1,0,0,1,142.67,123.67ZM126.32,121a.35.35,0,0,0-.35.35v1.25a.35.35,0,0,0,.35.35h16.36a.35.35,0,0,0,.35-.35v-1.25a.35.35,0,0,0-.35-.35Z'
				/>
				<path className='cls-2' d='M131.47,123.67H129.2a.38.38,0,0,1,0-.75h2.27a.37.37,0,0,1,0,.75Z' />
				<path className='cls-12' d='M154.05,119.81H114.94a.38.38,0,0,1,0-.75h39.12a.38.38,0,0,1,0,.75Z' />
				<path
					className='cls-2'
					d='M155.75,119.12h-5.51a.38.38,0,0,1,0-.75h5.51a.35.35,0,0,0,.35-.35v-3.19a.35.35,0,0,0-.35-.35H113.44a.35.35,0,0,0-.35.35V118a.35.35,0,0,0,.35.35h34.28a.37.37,0,0,1,0,.75H113.44a1.1,1.1,0,0,1-1.1-1.1v-3.19a1.1,1.1,0,0,1,1.1-1.1h42.31a1.1,1.1,0,0,1,1.1,1.1V118A1.1,1.1,0,0,1,155.75,119.12Z'
				/>
				<g className='cls-13'>
					<path
						className='cls-14'
						d='M139.93,140.68H130a.29.29,0,0,1-.29-.29V127a.29.29,0,0,1,.29-.29h7.28a.29.29,0,0,1,.2.08l2.64,2.61a.29.29,0,0,1,.09.2V140.4A.29.29,0,0,1,139.93,140.68Z'
					/>
				</g>
				<path className='cls-15' d='M140,129.46h-2.25a.29.29,0,0,1-.29-.29v-2.25Z' />
				<path className='cls-16' d='M135.78,133h-5a.38.38,0,0,1,0-.75h5a.38.38,0,0,1,0,.75Z' />
				<path className='cls-16' d='M139,137.75h-8.23a.38.38,0,0,1,0-.75H139a.38.38,0,0,1,0,.75Z' />
				<path className='cls-16' d='M139,134.61h-8.23a.38.38,0,0,1,0-.75H139a.38.38,0,0,1,0,.75Z' />
				<path className='cls-16' d='M139,136.18h-8.23a.38.38,0,0,1,0-.75H139a.38.38,0,0,1,0,.75Z' />
				<path
					className='cls-2'
					d='M139.75,141.42h-9.92a.66.66,0,0,1-.66-.66V127.4a.66.66,0,0,1,.66-.66h7.28a.66.66,0,0,1,.46.19l2.64,2.61a.66.66,0,0,1,.2.47v10.75A.66.66,0,0,1,139.75,141.42Zm-9.83-.75h9.74V130L137,127.46l-7.13,0Zm-.09-13.18h0Z'
				/>
				<path
					className='cls-2'
					d='M139.72,130.2h-2.11a.66.66,0,0,1-.66-.66v-2.36l.26-.15a.44.44,0,0,1,.47.09l2.52,2.52-.08.29A.43.43,0,0,1,139.72,130.2Zm-2-.75h1.25l-1.25-1.25Z'
				/>
				<path className='cls-2' d='M135.6,133.4h-5a.37.37,0,0,1,0-.75h5a.37.37,0,0,1,0,.75Z' />
				<path className='cls-2' d='M138.86,138.11h-8.23a.38.38,0,0,1,0-.75h8.23a.38.38,0,0,1,0,.75Z' />
				<path className='cls-2' d='M138.86,135h-8.23a.37.37,0,0,1,0-.75h8.23a.38.38,0,0,1,0,.75Z' />
				<path className='cls-2' d='M138.86,136.54h-8.23a.38.38,0,0,1,0-.75h8.23a.38.38,0,0,1,0,.75Z' />
				<path
					className='cls-17'
					d='M149.15,101.92l-2.38-6a.18.18,0,0,1,0-.1l1.84-10.49a.18.18,0,0,1,0-.09l4.26-4.79a.18.18,0,0,1,.32.15l-3.72,21.24A.18.18,0,0,1,149.15,101.92Z'
				/>
				<path
					className='cls-2'
					d='M149.32,102.41a.55.55,0,0,1-.52-.35l-2.38-6a.56.56,0,0,1,0-.3l1.84-10.49a.54.54,0,0,1,.13-.27l4.26-4.79a.56.56,0,0,1,1,.47L149.87,102a.55.55,0,0,1-.49.46Zm.18-.63h0Zm-2.36-5.91,2.11,5.27,3.49-19.9L149,85.5ZM149,85.43h0Zm3.88-4.85h0Z'
				/>
				<path
					className='cls-17'
					d='M148.26,102l-2.38-6a.18.18,0,0,1,0-.1l1.84-10.49a.18.18,0,0,1,0-.09L152,80.61a.18.18,0,0,1,.32.15L148.61,102A.18.18,0,0,1,148.26,102Z'
				/>
				<path
					className='cls-2'
					d='M148.43,102.53a.55.55,0,0,1-.52-.35h0l-2.38-6a.55.55,0,0,1,0-.3l1.84-10.49a.56.56,0,0,1,.13-.27l4.26-4.79a.56.56,0,0,1,1,.47L149,102.07a.55.55,0,0,1-.49.46ZM146.25,96l2.11,5.28,3.49-19.9-3.78,4.24Zm0-.05h0ZM152,80.7h0Z'
				/>
				<path
					className='cls-17'
					d='M147.38,102.16l-2.38-6a.18.18,0,0,1,0-.1l1.84-10.49a.18.18,0,0,1,0-.09l4.26-4.79a.18.18,0,0,1,.32.15l-3.72,21.24A.18.18,0,0,1,147.38,102.16Z'
				/>
				<path
					className='cls-2'
					d='M147.54,102.65a.55.55,0,0,1-.51-.35h0l-2.38-6a.57.57,0,0,1,0-.3l1.84-10.49a.56.56,0,0,1,.13-.27l4.26-4.79a.56.56,0,0,1,1,.47l-3.72,21.24a.55.55,0,0,1-.49.46Zm-2.18-6.54,2.11,5.28L151,81.49l-3.78,4.25Zm5.71-15.29h0Z'
				/>
				<path
					className='cls-17'
					d='M146.49,102.27l-2.38-6a.18.18,0,0,1,0-.1l1.84-10.49a.18.18,0,0,1,0-.09l4.26-4.79a.18.18,0,0,1,.32.15l-3.72,21.24A.18.18,0,0,1,146.49,102.27Z'
				/>
				<path
					className='cls-2'
					d='M146.65,102.76a.55.55,0,0,1-.52-.35h0l-2.38-6a.55.55,0,0,1,0-.3l1.84-10.49a.56.56,0,0,1,.13-.27L150,80.6a.56.56,0,0,1,1,.46L147.2,102.3a.55.55,0,0,1-.49.46Zm.18-.63h0Zm-2.36-5.91,2.11,5.28,3.49-19.9-3.78,4.24Zm0-.05h0Z'
				/>
				<path
					className='cls-17'
					d='M145.6,102.39l-2.38-6a.18.18,0,0,1,0-.1L145,85.85a.18.18,0,0,1,0-.09L149.35,81a.18.18,0,0,1,.32.15l-3.72,21.24A.18.18,0,0,1,145.6,102.39Z'
				/>
				<path
					className='cls-2'
					d='M145.76,102.88a.55.55,0,0,1-.51-.35h0l-2.38-6a.57.57,0,0,1,0-.3l1.84-10.49a.56.56,0,0,1,.13-.27l4.26-4.79a.56.56,0,0,1,1,.46l-3.72,21.24a.55.55,0,0,1-.49.46Zm.18-.63h0Zm-2.36-5.91,2.11,5.28,3.49-19.9L145.41,86Z'
				/>
				<path
					className='cls-17'
					d='M144.71,102.51l-2.38-6a.18.18,0,0,1,0-.1L144.16,86a.18.18,0,0,1,0-.09l4.26-4.79a.18.18,0,0,1,.32.15l-3.72,21.24A.18.18,0,0,1,144.71,102.51Z'
				/>
				<path
					className='cls-2'
					d='M144.88,103a.55.55,0,0,1-.52-.35h0l-2.38-6a.55.55,0,0,1,0-.3l1.84-10.49a.55.55,0,0,1,.13-.27l4.26-4.79a.56.56,0,0,1,1,.46l-3.72,21.24a.55.55,0,0,1-.49.46Zm.18-.63h0Zm-2.36-5.91,2.11,5.28,3.49-19.9-3.78,4.24Zm0-.05h0Z'
				/>
				<path
					className='cls-17'
					d='M143.82,102.62l-2.38-6a.18.18,0,0,1,0-.1l1.84-10.49a.18.18,0,0,1,0-.09l4.26-4.79a.18.18,0,0,1,.32.15l-3.72,21.24A.18.18,0,0,1,143.82,102.62Z'
				/>
				<path
					className='cls-2'
					d='M144,103.11a.55.55,0,0,1-.52-.35l-2.38-6a.58.58,0,0,1,0-.3L142.9,86a.55.55,0,0,1,.13-.27l4.26-4.79a.56.56,0,0,1,1,.46l-3.72,21.24a.55.55,0,0,1-.49.46Zm.18-.63h0Zm-2.36-5.91,2.11,5.27L147.41,82l-3.78,4.24Zm1.83-10.44h0Z'
				/>
				<path
					className='cls-17'
					d='M142,102.74l-2.38-6a.18.18,0,0,1,0-.1l1.84-10.49a.18.18,0,0,1,0-.09l4.26-4.79a.18.18,0,0,1,.32.15l-3.72,21.24A.18.18,0,0,1,142,102.74Z'
				/>
				<path
					className='cls-2'
					d='M142.21,103.23a.55.55,0,0,1-.51-.35l-2.38-6a.55.55,0,0,1,0-.3l1.84-10.49a.55.55,0,0,1,.13-.27l4.26-4.79a.56.56,0,0,1,1,.47l-3.72,21.24a.55.55,0,0,1-.49.46Zm.18-.63h0ZM140,96.7l2.11,5.27,3.49-19.9-3.77,4.24Zm0-.05h0Zm6.07-15.08h0Zm-.34-.16h0Z'
				/>
				<path
					className='cls-17'
					d='M143.67,97.68l-2.38-6a.18.18,0,0,1,0-.1l1.84-10.49a.18.18,0,0,1,0-.09l4.26-4.79a.18.18,0,0,1,.32.15L144,97.65A.18.18,0,0,1,143.67,97.68Z'
				/>
				<path
					className='cls-2'
					d='M143.83,98.17a.55.55,0,0,1-.51-.35h0l-2.38-6a.55.55,0,0,1,0-.3l1.84-10.49a.55.55,0,0,1,.14-.28L147.14,76a.56.56,0,0,1,1,.47l-3.72,21.24a.55.55,0,0,1-.49.46Zm-2.18-6.54,2.11,5.28L147.25,77l-3.78,4.25Zm0-.05h0Zm1.81-10.29h0Zm3.92-5h0Z'
				/>
				<path
					className='cls-17'
					d='M141.15,102.61l-2.38-6a.18.18,0,0,1,0-.1l1.84-10.49a.18.18,0,0,1,0-.09l4.26-4.79a.18.18,0,0,1,.32.15l-3.72,21.24A.18.18,0,0,1,141.15,102.61Z'
				/>
				<path
					className='cls-2'
					d='M141.32,103.1a.55.55,0,0,1-.51-.35l-2.38-6a.55.55,0,0,1,0-.3L140.24,86a.54.54,0,0,1,.13-.27l4.26-4.79a.56.56,0,0,1,1,.47l-3.72,21.24a.55.55,0,0,1-.49.46Zm.18-.63h0Zm-2.36-5.91,2.11,5.27,3.49-19.9L141,86.18Zm0-.05h0ZM141,86.12h0Zm3.88-4.85h0Z'
				/>
				<path
					className='cls-17'
					d='M140.27,102.73l-2.38-6a.18.18,0,0,1,0-.1l1.84-10.49a.18.18,0,0,1,0-.09L144,81.3a.18.18,0,0,1,.32.15l-3.72,21.24A.18.18,0,0,1,140.27,102.73Z'
				/>
				<path
					className='cls-2'
					d='M140.43,103.22a.55.55,0,0,1-.51-.35h0l-2.38-6a.57.57,0,
0,1,0-.3l1.84-10.49a.56.56,0,0,1,.13-.27l4.26-4.79a.56.56,0,0,1,1,.47L141,102.75a.55.55,0,0,1-.49.46Zm.18-.63h0Zm-2.36-5.91,2.11,5.28,3.49-19.9-3.78,4.25ZM144,81.39h0Z'
				/>
				<path
					className='cls-17'
					d='M139.38,102.84l-2.38-6a.18.18,0,0,1,0-.1l1.84-10.49a.18.18,0,0,1,0-.09l4.26-4.79a.18.18,0,0,1,.32.15l-3.72,21.24A.18.18,0,0,1,139.38,102.84Z'
				/>
				<path
					className='cls-2'
					d='M139.54,103.33A.55.55,0,0,1,139,103h0l-2.38-6a.55.55,0,0,1,0-.3l1.84-10.49a.56.56,0,0,1,.13-.27l4.26-4.79a.56.56,0,0,1,1,.47l-3.72,21.24a.55.55,0,0,1-.49.46Zm.18-.63h0Zm-2.36-5.91,2.11,5.28L143,82.17l-3.78,4.24Zm0-.05h0Zm5.73-15.24h0Z'
				/>
				<path
					className='cls-17'
					d='M138.49,103l-2.38-6a.18.18,0,0,1,0-.1l1.84-10.49a.18.18,0,0,1,0-.09l4.26-4.79a.18.18,0,0,1,.32.15l-3.72,21.24A.18.18,0,0,1,138.49,103Z'
				/>
				<path
					className='cls-2'
					d='M138.65,103.45a.55.55,0,0,1-.51-.35h0l-2.38-6a.57.57,0,0,1,0-.3l1.84-10.49a.55.55,0,0,1,.13-.27L142,81.29a.56.56,0,0,1,1,.46L139.21,103a.55.55,0,0,1-.49.46Zm.18-.63h0Zm-2.36-5.91,2.11,5.28,3.49-19.9-3.78,4.25Zm1.83-10.43h0Z'
				/>
				<path
					className='cls-17'
					d='M137.6,103.08l-2.38-6a.18.18,0,0,1,0-.1L137,86.53a.18.18,0,0,1,0-.09l4.26-4.79a.18.18,0,0,1,.32.15L137.95,103A.18.18,0,0,1,137.6,103.08Z'
				/>
				<path
					className='cls-2'
					d='M137.77,103.57a.55.55,0,0,1-.52-.35h0l-2.38-6a.55.55,0,0,1,0-.3l1.84-10.49a.55.55,0,0,1,.13-.27l4.26-4.79a.56.56,0,0,1,1,.46l-3.72,21.24a.55.55,0,0,1-.49.46Zm.18-.63h0ZM135.59,97l2.11,5.28,3.49-19.9-3.78,4.24Zm0-.05h0Z'
				/>
				<path
					className='cls-17'
					d='M136.71,103.19l-2.38-6a.18.18,0,0,1,0-.1l1.84-10.49a.18.18,0,0,1,0-.09l4.26-4.79a.18.18,0,0,1,.32.15l-3.72,21.24A.18.18,0,0,1,136.71,103.19Z'
				/>
				<path
					className='cls-2'
					d='M136.88,103.68a.55.55,0,0,1-.51-.35h0l-2.38-6a.57.57,0,0,1,0-.3l1.84-10.49a.55.55,0,0,1,.13-.27l4.26-4.79a.56.56,0,0,1,1,.46l-3.72,21.24a.55.55,0,0,1-.49.46Zm.18-.63h0Zm-2.36-5.91,2.11,5.28,3.49-19.9-3.78,4.24Zm1.83-10.43h0Z'
				/>
				<path className='cls-17' d='M129.11,73.43s-1.29-4.57-5.57-2.25l-4.19,23.38,3-1.29Z' />
				<path
					className='cls-3'
					d='M125.88,74.14a2.1,2.1,0,0,1-1.38-.46,2.82,2.82,0,0,1-.79-2.23.37.37,0,0,1,.75.07,2.09,2.09,0,0,0,.52,1.59,2,2,0,0,0,1.84.13c0-.05-.05-.27-.32-.52a1.15,1.15,0,0,0-.57-.34,2.21,2.21,0,0,0,0,.41.37.37,0,1,1-.74.13c-.18-1,.32-1.22.54-1.27.66-.15,1.65.71,1.82,1.39A.73.73,0,0,1,127,74,4.26,4.26,0,0,1,125.88,74.14Z'
				/>
				<path
					className='cls-3'
					d='M123.3,88.22h-.1a.38.38,0,0,1-.26-.46l3.89-14.33a.37.37,0,0,1,.46-.26.38.38,0,0,1,.26.46l-3.89,14.33A.38.38,0,0,1,123.3,88.22Z'
				/>
				<path
					className='cls-2'
					d='M119.34,95.28,123.68,71l.16-.09a4.2,4.2,0,0,1,3.71-.45,4.82,4.82,0,0,1,2.39,2.92l0,.11,0,.11-6.81,20Zm5-23.75-4,22.51,2.21-1,6.66-19.56a4,4,0,0,0-1.93-2.33A3.41,3.41,0,0,0,124.36,71.52Z'
				/>
				<path
					className='cls-2'
					d='M126.4,74.22a2.5,2.5,0,0,1-1.47-.44,3.61,3.61,0,0,1-1.29-2.47.37.37,0,0,1,.34-.4.37.37,0,0,1,.4.34,2.89,2.89,0,0,0,1,1.92,2.21,2.21,0,0,0,1.92.17c0-.05-.05-.27-.32-.52a1.15,1.15,0,0,0-.57-.34,2.33,2.33,0,0,0,0,.41.38.38,0,0,1-.3.43.37.37,0,0,1-.43-.3c-.18-1,.32-1.22.54-1.27.67-.15,1.65.71,1.82,1.39a.73.73,0,0,1-.56.93A4,4,0,0,1,126.4,74.22Z'
				/>
				<path
					className='cls-2'
					d='M123.77,88.32h-.1a.38.38,0,0,1-.26-.46l3.89-14.33a.38.38,0,0,1,.72.2L124.14,88A.38.38,0,0,1,123.77,88.32Z'
				/>
				<path className='cls-17' d='M109.7,73.74s1.06-8.27,9.08-5.33l13.28,39.5-5.54-1.47Z' />
				<path
					className='cls-3'
					d='M114.57,73.92a8.54,8.54,0,0,1-1.07-.07,1,1,0,0,1-1-1.16c.1-1.07,1.41-2.62,2.44-2.62H115c.39,0,1,.29,1,1.78a.38.38,0,0,1-.38.37.38.38,0,0,1-.37-.38c0-.61-.1-1-.29-1-.53,0-1.63,1.14-1.71,1.94,0,.2,0,.31.3.35,1.6.21,2.75-.06,3.41-.8a3.93,3.93,0,0,0,.56-3.14.37.37,0,0,1,.73-.18,4.64,4.64,0,0,1-.73,3.82A3.81,3.81,0,0,1,114.57,73.92Z'
				/>
				<path
					className='cls-3'
					d='M123.49,97.64a.38.38,0,0,1-.34-.22L112.71,73.55a.38.38,0,1,1,.69-.3l10.44,23.87a.38.38,0,0,1-.19.49A.37.37,0,0,1,123.49,97.64Z'
				/>
				<path
					className='cls-2'
					d='M122.29,81.88a.38.38,0,0,1-.36-.26L117.68,69c-2.21-.77-4.06-.73-5.5.15-2.2,1.34-2.8,4.23-2.9,4.83l.9,1.76a.37.37,0,1,1-.67.34l-1-2V74c0-.15.52-3.81,3.27-5.49,1.67-1,3.8-1.07,6.31-.15l.17.06,4.37,13a.37.37,0,0,1-.24.47Z'
				/>
				<path
					className='cls-2'
					d='M131.84,108.73,125.47,107l-.08-.15-14.93-29a.37.37,0,0,1,.67-.34L126,106.4l4.71,1.25-8.15-24.23a.37.37,0,0,1,.71-.24Z'
				/>
				<path
					className='cls-2'
					d='M113.68,74.19a7.84,7.84,0,0,1-1-.07,1,1,0,0,1-1-1.16c.1-1.09,1.44-2.69,2.5-2.62.39,0,1,.29,1,1.78a.36.36,0,0,1-.39.36.38.38,0,0,1-.36-.39c0-.61-.09-1-.29-1h0c-.52,0-1.62,1.15-1.69,1.94,0,.2,0,.31.31.35a4.15,4.15,0,0,0,3.52-.86,5.34,5.34,0,0,0,1.28-3.8.37.37,0,0,1,.35-.4.37.37,0,0,1,.4.35,6,6,0,0,1-1.51,4.4A4.42,4.42,0,0,1,113.68,74.19Z'
				/>
				<path
					className='cls-2'
					d='M122.69,97.92a.38.38,0,0,1-.34-.22L111.91,73.83a.38.38,0,0,1,.69-.3L123,97.4a.38.38,0,0,1-.19.49A.37.37,0,0,1,122.69,97.92Z'
				/>
				<path className='cls-17' d='M132.74,80.57s-1.72-6.11-7.44-3l-5.6,31.25,4-1.73Z' />
				<path
					className='cls-3'
					d='M128.42,81.39a2.68,2.68,0,0,1-1.77-.58,3.63,3.63,0,0,1-1-2.88.37.37,0,0,1,.75.07,2.93,2.93,0,0,0,.75,2.23,2.78,2.78,0,0,0,2.57.2c.16,0,.15-.08.13-.19-.13-.53-1.05-1.26-1.4-1.21-.05,0-.12.23,0,.69a.38.38,0,0,1-.3.43.37.37,0,0,1-.43-.3c-.21-1.19.3-1.49.62-1.55.8-.18,2.08.92,2.28,1.76a.85.85,0,0,1-.65,1.09A5.56,5.56,0,0,1,128.42,81.39Z'
				/>
				<path
					className='cls-3'
					d='M125,100.22h-.1a.38.38,0,0,1-.26-.46l5.2-19.15a.38.38,0,1,1,.72.2l-5.2,19.15A.38.38,0,0,1,125,100.22Z'
				/>
				<path
					className='cls-2'
					d='M119.84,109.57l5.75-32.12.16-.09a5.5,5.5,0,0,1,4.85-.6,6.3,6.3,0,0,1,3.13,3.83l0,.11,0,.11-9.08,26.68Zm6.43-31.63-5.44,30.39,3.22-1.39L133,80.69a5.51,5.51,0,0,0-2.67-3.24A4.7,4.7,0,0,0,126.27,77.94Z'
				/>
				<path
					className='cls-2'
					d='M129.12,81.5a3.22,3.22,0,0,1-1.89-.56,4.69,4.69,0,0,1-1.67-3.21.37.37,0,0,1,.34-.4.37.37,0,0,1,.4.34,4,4,0,0,0,1.36,2.66,3.07,3.07,0,0,0,2.67.24c.16,0,.15-.08.13-.19-.13-.53-1.06-1.28-1.4-1.21-.05,0-.12.23,0,.69a.37.37,0,1,1-.74.13c-.21-1.19.3-1.49.62-1.55.8-.18,2.08.92,2.28,1.76a.85.85,0,0,1-.65,1.09A5.29,5.29,0,0,1,129.12,81.5Z'
				/>
				<path
					className='cls-2'
					d='M125.6,100.34h-.1a.38.38,0,0,1-.26-.46l5.2-19.16a.38.38,0,0,1,.72.2L126,100.07A.38.38,0,0,1,125.6,100.34Z'
				/>
				<path className='cls-8' d='M153.14,113.46h-36a2,2,0,0,1-2-2V88.25h40v23.21A2,2,0,0,1,153.14,113.46Z' />
				<rect className='cls-4' x='126.31' y='90.34' width='17.51' height='2.66' rx='1.33' ry='1.33' />
				<path className='cls-12' d='M154.29,89H115.84a.38.38,0,0,1,0-.75h38.44a.38.38,0,0,1,0,.75Z' />
				<path
					className='cls-2'
					d='M154,114.12H115.18a.94.94,0,0,1-.94-.94v-17a.37.37,0,0,1,.75,0v17a.19.19,0,0,0,.19.19H154a.19.19,0,0,0,.19-.19V89.28L115,89.22v3.89a.38.38,0,0,1-.75,0V89a.56.56,0,0,1,.56-.56l39.6.05a.56.56,0,0,1,.56.56v24.1A.94.94,0,0,1,154,114.12Z'
				/>
				<path
					className='cls-2'
					d='M141.92,93.66H127.08a1.71,1.71,0,1,1,0-3.41h14.84a1.71,1.71,0,0,1,0,3.41ZM127.08,91a1,1,0,1,0,0,1.91h14.84a1,1,0,0,0,0-1.91Z'
				/>
				<rect className='cls-10' x='125.98' y='99.23' width='18.18' height='6.44' rx='1' ry='1' />
				<path
					className='cls-2'
					d='M142.78,106.42H126.6a1.38,1.38,0,0,1-1.37-1.37v-4.44a1.38,1.38,0,0,1,1.38-1.38h16.18a1.38,1.38,0,0,1,1.38,1.38V105A1.38,1.38,0,0,1,142.78,106.42ZM126.6,100a.63.63,0,0,0-.62.63V105a.63.63,0,0,0,.63.63h16.18a.63.63,0,0,0,.63-.62v-4.44a.63.63,0,0,0-.62-.63Z'
				/>
				<path className='cls-2' d='M139.61,102.16h-9.85a.38.38,0,0,1,0-.75h9.85a.38.38,0,0,1,0,.75Z' />
				<path className='cls-2' d='M140.56,104.44H128.82a.38.38,0,0,1,0-.75h11.74a.38.38,0,0,1,0,.75Z' />
				<path
					className='cls-2'
					d='M180.65,143.17a.38.38,0,0,1-.37-.37v-3.3a.38.38,0,0,1,.75,0v3.3A.38.38,0,0,1,180.65,143.17Z'
				/>
				<path
					className='cls-17'
					d='M180.44,138.72H157.22a.36.36,0,0,0-.34.24,6.6,6.6,0,0,0,0,4,.36.36,0,0,0,.34.22h23.23'
				/>
				<path
					className='cls-18'
					d='M182.71,143.38H156.86a.73.73,0,0,1-.66-.4,5.38,5.38,0,0,1,0-4,.74.74,0,0,1,.68-.45h25.83a.38.38,0,1,1,0,.75H156.88a4.71,4.71,0,0,0,0,3.35l25.84,0a.38.38,0,0,1,0,.75Z'
				/>
				<path
					className='cls-2'
					d='M183.13,144H156.38a.74.74,0,0,1-.69-.46,7.7,7.7,0,0,1,0-4.93.74.74,0,0,1,.7-.51h26.73a.38.38,0,1,1,0,.75H156.4a7.15,7.15,0,0,0,0,4.43h26.73a.38.38,0,1,1,0,.75Z'
				/>
				<rect className='cls-19' x='159.83' y='133.09' width='24.33' height='3.9' rx='1' ry='1' />
				<path
					className='cls-3'
					d='M180.72,137.18a.38.38,0,0,1-.37-.37v-3.44a.38.38,0,0,1,.75,0v3.44A.38.38,0,0,1,180.72,137.18Z'
				/>
				<path
					className='cls-3'
					d='M178.88,137.18a.38.38,0,0,1-.37-.37v-3.44a.38.38,0,0,1,.75,0v3.44A.38.38,0,0,1,178.88,137.18Z'
				/>
				<path
					className='cls-2'
					d='M182.93,137.6H160.6a1.38,1.38,0,0,1-1.37-1.37v-1.9a1.38,1.38,0,0,1,1.38-1.37h22.33a1.38,1.38,0,0,1,1.38,1.38v1.9A1.38,1.38,0,0,1,182.93,137.6Zm-22.33-3.9a.63.63,0,0,0-.62.63v1.9a.63.63,0,0,0,.63.63h22.33a.63.63,0,0,0,.63-.62v-1.9a.63.63,0,0,0-.62-.62Z'
				/>
				<path
					className='cls-2'
					d='M180.49,137.41a.38.38,0,0,1-.37-.37v-3.44a.38.38,0,0,1,.75,0V137A.38.38,0,0,1,180.49,137.41Z'
				/>
				<path
					className='cls-2'
					d='M178.65,134.84a.38.38,0,0,1-.37-.37v-.88a.38.38,0,0,1,.75,0v.88A.38.38,0,0,1,178.65,134.84Z'
				/>
				<path
					className='cls-2'
					d='M178.65,137.41a.38.38,0,0,1-.37-.37V136a.38.38,0,0,1,.75,0V137A.38.38,0,0,1,178.65,137.41Z'
				/>
				<path
					className='cls-2'
					d='M180.91,132.22a.38.38,0,0,1-.37-.37v-2.51a.38.38,0,0,1,.75,0v2.51A.38.38,0,0,1,180.91,132.22Z'
				/>
				<path
					className='cls-17'
					d='M180.74,129H161.93a.36.36,0,0,0-.34.24,3.89,3.89,0,0,0,0,2.69.36.36,0,0,0,.33.21h18.83'
				/>
				<path
					className='cls-20'
					d='M182.59,132.37H161.93a.72.72,0,0,1-.65-.39,3.31,3.31,0,0,1,0-2.74.74.74,0,0,1,.68-.45h20.64a.38.38,0,0,1,0,.75H161.94a2.6,2.6,0,0,0,0,2.09l20.64,0a.38.38,0,0,1,0,.75Z'
				/>
				<path
					className='cls-2'
					d='M182.92,132.85H161.25a.74.74,0,0,1-.69-.46,5.66,5.66,0,0,1,0-3.71.74.74,0,0,1,.7-.5h21.66a.38.38,0,0,1,0,.75H161.26a5,5,0,0,0,0,3.19h21.66a.37.37,0,0,1,0,.75Z'
				/>
				<rect className='cls-21' x='164.32' y='121.28' width='18.19' height='6.03' rx='1' ry='1' />
				<path
					className='cls-3'
					d='M179.93,127.39a.38.38,0,0,1-.37-.37v-5.32a.38.38,0,0,1,.75,0V127A.38.38,0,0,1,179.93,127.39Z'
				/>
				<path
					className='cls-3'
					d='M178.56,127.39a.38.38,0,0,1-.37-.37v-5.32a.38.38,0,1,1,.75,0V127A.38.38,0,0,1,178.56,127.39Z'
				/>
				<path
					className='cls-2'
					d='M182,128H164.51a.74.74,0,0,1-.74-.74V122a.74.74,0,0,1,.74-.74h3.58a.38.38,0,0,1,0,.75h-3.58v5.29H182V122H170.34a.38.38,0,0,1,0-.75H182a.74.74,0,0,1,.74.74v5.3A.74.74,0,0,1,182,128Z'
				/>
				<path
					className='cls-2'
					d='M179.76,127.74a.38.38,0,0,1-.37-.37V122a.38.38,0,1,1,.75,0v5.32A.38.38,0,0,1,179.76,127.74Z'
				/>
				<path
					className='cls-2'
					d='M178.39,127.74a.38.38,0,0,1-.37-.37V122a.38.38,0,0,1,.75,0v5.
32A.38.38,0,0,1,178.39,127.74Z'
				/>
				<path
					className='cls-22'
					d='M 198.63,144.87 H 1.37 a 0.37,0.37 0 1 1 0,-0.74 h 197.26 a 0.37,0.37 0 0 1 0,0.74 z'
				/>
			</svg>
		</div>
	);
}

export { ActivityImage };
